// How far ahead booking calendars let users pick a date (DEV-885).
// Mirrors AvailabilityService::MONTHS_IN_ADVANCE on the API, which bounds the open dates returned.
export const BOOKING_HORIZON_MONTHS = 12
